import { useCallback } from 'react';

import { VisitTemplate, VisitTemplateCreateCommand } from '@dreryk/egabinet-visit-frontend-api';

import { PromiseVoidFunction } from '@dreryk/react-common';
import { Choice } from '@dreryk/watermelon';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { visitTemplatesTranslationKeys } from '../translations';

import { VisitTemplateFormBean, VisitTemplateFormController } from './form/VisitTemplateForm.types';

type VisitTemplatesCreateTemplateButtonProps = {
   readonly handleSubmit: VisitTemplateFormController['handleSubmit'];
   readonly onSuccess: PromiseVoidFunction;
   readonly disabled: boolean;
   readonly shouldConfirmEmptyTemplate: boolean;
};

export const VisitTemplatesCreateTemplateButton = (props: VisitTemplatesCreateTemplateButtonProps): JSX.Element => {
   const commandCreator = useCallback((variables: VisitTemplateFormBean) => {
      const command = new VisitTemplateCreateCommand();
      command.parameters = {
         name: variables.name,
         interview: Choice.withUseDefaultIfNull(variables.interview?.getFormattedValue() ?? null),
         physicalExamination: Choice.withUseDefaultIfNull(variables.subjectiveAssessment?.getFormattedValue() ?? null),
         recommendations: Choice.withUseDefaultIfNull(variables.recommendations?.getFormattedValue() ?? null),
      };
      return command;
   }, []);
   return (
      <FormsTemplates.SendTemplateButton<VisitTemplateFormBean, VisitTemplate>
         disabled={props.disabled}
         handleSubmit={props.handleSubmit}
         commandCreator={commandCreator}
         onSuccess={props.onSuccess}
         shouldConfirm={{
            enabled: props.shouldConfirmEmptyTemplate,
            title: visitTemplatesTranslationKeys.savingEmptyTemplate,
            content: visitTemplatesTranslationKeys.doYouWantToSaveEmptyTemplate,
         }}
      />
   );
};
